import type { RouteLocationAsRelative } from 'vue-router'

import { TimeOffRequestID } from './models/timeOffRequest'

export interface TimeOffRef {
  id: TimeOffRequestID
  orgSlug: string
}

export const timeOffRoutes = {
  list: (
    org: string,
  ): RouteLocationAsRelative<'/(app)/[org]/people/time-off/'> => ({
    name: '/(app)/[org]/people/time-off/',
    params: { org },
  }),

  create: (
    org: string,
  ): RouteLocationAsRelative<'/(app)/[org]/people/time-off.create'> => ({
    name: '/(app)/[org]/people/time-off.create',
    params: { org },
  }),

  detail: (
    t: TimeOffRef,
  ): RouteLocationAsRelative<'/(app)/[org]/people/time-off/[id]/'> => ({
    name: '/(app)/[org]/people/time-off/[id]/',
    params: { org: t.orgSlug, id: t.id },
  }),
}
